export function getProductHtml(productShortView, serial, reference) {
    const applicationProperties = require('../../../../applicationProperties.json'),
            productImageUrl = applicationProperties.productImageUrl,
            bookDefaultImage = applicationProperties.bookDefaultImage,
            nonBookDefaultImage = applicationProperties.nonBookDefaultImage,
            contextPath = $('meta[name=context-path]').attr('content').trim(),
            discount = Number(productShortView.discountPercentage),
            averageRating = Number(productShortView.averageRating),
            fullStar = Math.floor(averageRating),
            halfStar = (averageRating % 1 != 0 ? 1 : 0),
            emptyStar = 5 - fullStar - halfStar;

    let defaultSrcUrl = "";

    if (productShortView.productType == 1 || productShortView.productType == 8) {
        defaultSrcUrl = bookDefaultImage;
    } else {
        defaultSrcUrl = nonBookDefaultImage
    }

    if (!serial) {
        serial = 0;
    }
    if (!reference) {
        reference = '';
    }

    let htmlStar = '';

    if(averageRating > 0) {
        for (let i = 0; i < fullStar; i++) {
            htmlStar += '<i class="ion-ios-star"></i>';
        }

        for (let i = 0; i < halfStar; i++) {
            htmlStar += '<i class="ion-ios-star-half"></i>';
        }
        for (let i = 0; i < emptyStar; i++) {
            htmlStar += '<i class="ion-ios-star-outline"></i>';
        }
    }

    return `
            <div class="book-list-wrapper
                ${productShortView.status === 0 ? ' back-order' : ''}
                ${productShortView.status === 2 ? ' not-available' : ''}
                ${productShortView.categoryId === 2102 ? ' gift-voucher' : ''}
                ${productShortView.status === 5 ? ' pre-order' : ''}"
            >
                <a href="${contextPath}${productShortView.url}?ref=${reference}" target="_blank" title="${productShortView.title}&#13;&#10;${productShortView.subTitle}">
                    <div class="book-img">
                        <img src="${defaultSrcUrl}" data-src="${productImageUrl}/130X186/${productShortView.avatar}" alt="${productShortView.englishName}">

                        ${(discount > 0 && discount <= 24) ? `<div class="discount-badge-common badge-yellow"><p>${discount > 0 && discount <= 9 ? '0' : ''}${discount}</p></div>` : ''}
                        ${(discount >= 25 && discount <= 99) ? `<div class="discount-badge-common badge-common"><p>${discount}</p></div>` : ''}
                        
                        ${(productShortView.status === 5) ? `<div class="pre-order-badge"></div>` : ''}
                        ${productShortView.status === 0 ? `<div class="pre-order-badge back-order-badge"></div>` : ''}
                        ${(productShortView.status === 2) ? `<div class="out-of-stock-badge"></div>` : ''}
                        ${productShortView.isLookInsideAvailable ? `<div class="look-inside-badge"></div>` : ''}
                        ${serial > 0 ? `<div class="serial-badge"><p>${serial}</p></div>` : ''}
                        ${(productShortView.productOrderType === 'NORMAL') ? `
                            <div class="cart-btn-area">
                                <button class="btn cart-btn js--add-to-cart ${location.pathname == '/boimela' ? 'js--abtest-boimela-recommendation' : ''}" product-id="${productShortView.id}" onClick="ecomEventEmit('add_to_cart', 'RokHomeProduct', '${productShortView.id}', '${productShortView.categoryId == null ? 0 : productShortView.categoryId}', '${productShortView.price}');ga('send', 'event', 'HomeProductList', 'Click', 'HomeProductList-Click_on_HomeProductList_AddToCart_Button-Click');">
                                    Add to Cart
                                </button>
                            </div>` : ''
                        }
                    </div>

                    <div class="book-text-area">
                        <h4 class="book-title">${productShortView.title}</h4>
                        <p class="book-author">${productShortView.subTitle}</p>
                        <div class="rating-section text-center ${htmlStar == '' ? 'd-none' : ''}">
                            ${htmlStar} ${productShortView.numberOfRating > 0 ? `<span class="text-secondary">(${productShortView.numberOfRating})</span>` : ''}
                        </div>
                        <p class="book-status text-capitalize">${(productShortView.inStock && productShortView.productOrderType === 'NORMAL') ? 'Product in stock' : ''}</p>
                        <p class="book-price">
                            ${discount > 13 ? `<strike class="original-price">
                                ${productShortView.productType === 8 ? productShortView.mrpWithCurrency : `TK. ${formatNumber(productShortView.mrp)}`}
                            </strike>` : ''}
                            ${productShortView.productType === 8 ? productShortView.priceWithCurrency : `TK. ${formatNumber(productShortView.price)}`}
                        </p>
                    </div>
                </a>
                <div class="home-details-btn-wrapper ${location.pathname == '/cart/new' ? 'd-none' : ''}">
                    <a class="btn home-details-btn transparent-background btn-block ${location.pathname == '/cart/new' ? 'd-none' : ''}" target="_blank" href="${contextPath}${productShortView.url}?ref=${reference}">
                        View Details
                    </a>
                </div>
            </div>
    `;
}

export function getDealProductHtml(productShortView, serial, reference, isImageImmediateShow = false) {
    const dealDiscount = (1 -(productShortView.dealPrice / productShortView.mrp)) * 100;
    const applicationProperties = require('../../../../applicationProperties.json'),
            productImageUrl = applicationProperties.productImageUrl,
            bookDefaultImage = applicationProperties.bookDefaultImage,
            nonBookDefaultImage = applicationProperties.nonBookDefaultImage,
            contextPath = $('meta[name=context-path]').attr('content').trim(),
            discount = Math.round(dealDiscount)
            
            let imageSrc;

            if (isImageImmediateShow) {
                imageSrc = `${productImageUrl}/130X186/${productShortView.avatar}`;
            } else {
                if (productShortView.productType == 1 || productShortView.productType == 8) {
                    imageSrc = bookDefaultImage;
                } else {
                    imageSrc = nonBookDefaultImage;
                }
            }

    return `
            <div class="book-list-wrapper
                ${productShortView.status === 0 ? ' back-order' : ''}
                ${productShortView.status === 2 ? ' not-available' : ''}
                ${productShortView.categoryId === 2102 ? ' gift-voucher' : ''}
                ${productShortView.status === 5 ? ' pre-order' : ''}"
            >
                <a href="${contextPath}${productShortView.url}?ref=${reference}" target="_blank" title="${productShortView.title}&#13;&#10;${productShortView.subTitle}">
                    <div class="book-img">
                        <img src="${imageSrc}" data-src="${productImageUrl}/130X186/${productShortView.avatar}" alt="${productShortView.englishName}">

                        ${(discount > 0 && discount <= 24) ? `<div class="discount-badge-common badge-yellow"><p>${discount > 0 && discount <= 9 ? '0' : ''}${discount}</p></div>` : ''}
                        ${(discount >= 25 && discount <= 99) ? `<div class="discount-badge-common badge-common"><p>${discount}</p></div>` : ''}
                                                
                        ${(productShortView.status === 5) ? `<div class="pre-order-badge"></div>` : ''}
                        ${productShortView.status === 0 ? `<div class="pre-order-badge back-order-badge"></div>` : ''}
                        ${(productShortView.status === 2) ? `<div class="out-of-stock-badge"></div>` : ''}
                        ${productShortView.isLookInsideAvailable ? `<div class="look-inside-badge"></div>` : ''}
                        ${serial > 0 ? `<div class="serial-badge"><p>${serial}</p></div>` : ''}
                        ${(productShortView.productOrderType === 'NORMAL') ? `
                            <div class="cart-btn-area">
                                <button class="btn cart-btn js--add-to-cart" product-id="${productShortView.id}" onClick="ecomEventEmit('add_to_cart', 'RokHomeProduct', '${productShortView.id}', '${productShortView.categoryId == null ? 0 : productShortView.categoryId}', '${productShortView.price}');ga('send', 'event', 'HomeProductList', 'Click', 'HomeProductList-Click_on_HomeProductList_AddToCart_Button-Click');">
                                    Add to Cart
                                </button>
                            </div>` : ''
                        }
                    </div>

                    <div class="book-text-area">
                        <h4 class="book-title text-truncate">${productShortView.title}</h4>
                        <p class="book-author text-truncate">${productShortView.subTitle}</p>
                        
                        <p class="book-price">
                            ${productShortView.mrp === productShortView.dealPrice ? `
                                <span class="discount-price">৳${productShortView.dealPrice}</span>` : `<strike class="original-price">
                                ${productShortView.productType === 8 ? productShortView.mrpWithCurrency : `৳${formatNumber(productShortView.mrp)}`}
                            </strike> 
                            <span class="discount-price">৳${productShortView.dealPrice}</span> <span class="discount-percentage text-danger">${discount}% OFF</span> `}
                           

                        </p>
                    </div>
                </a>
                <div class="home-details-btn-wrapper">
                    <a class="btn home-details-btn transparent-background btn-block" target="_blank" href="${contextPath}${productShortView.url}?ref=${reference}">
                        View Details
                    </a>
                </div>
            </div>
    `;
}


function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}